import './App.css';
import TodoContainer from './components/TodoContainer';

function App() {
  return (
    <TodoContainer />

  );
}
export default App;
